import FormContainer from "components/Form/FormContainer";
import AppVersion from "components/Standalone/AppVersion";
import TabIdentity from "components/Navigation/TabIdentity";

export default function Login() {
    return (
        <div className="min-h-screen bg-canvas">
            <TabIdentity product="omci" content="Sign in" />
            <FormContainer>
                {/* Under the card on phones (a fixed label would cover the form); bottom-right of the viewport from sm up. */}
                <AppVersion className="mt-8 text-xs text-ink-muted sm:fixed sm:bottom-2 sm:right-6 sm:mt-0" />
            </FormContainer>
        </div>
    );
}
